export default "__VITE_ASSET__DVydP9V6__"